export const timeTableInit = () => {


    // Dual API refactor: 
    // 1. Schedule API (grouped_articles_cmn) -> Time, Place, Tags
    // 2. Content API (group_all) -> Title, Speakers, Info, Tags
    // Merge based on matching tags (e.g. #m01)

    const createModal = () => {
        const modal = document.createElement('div');
        modal.classList.add('timetable-modal');
        modal.innerHTML = `
            <div class="timetable-modal__overlay"></div>
            <div class="timetable-modal__content">
                <button class="timetable-modal__close">
                    <img src="./assets/images/modal-close.svg" alt="Close">
                </button>
                <div class="timetable-modal__body">
                    <!-- Content will be injected here -->
                </div>
            </div>
        `;
        document.body.appendChild(modal);

        const overlay = modal.querySelector('.timetable-modal__overlay');
        const closeBtn = modal.querySelector('.timetable-modal__close');

        const closeModal = () => {
            modal.classList.remove('is-active');
            document.documentElement.classList.remove('no-scroll');
            document.body.classList.remove('no-scroll');
        };

        overlay.addEventListener('click', closeModal);
        closeBtn.addEventListener('click', closeModal);

        return modal;
    };

    const modal = createModal();

    const openModal = (data) => {

        const modalBody = modal.querySelector('.timetable-modal__body');


        // Reset day classes
        modal.classList.remove('is-day27', 'is-day28');
        if (data._day) {
            modal.classList.add(`is-day${data._day}`);
        }

        const colors = [
            '#FE8B73', '#72EC5D', '#86C49F', '#CFB5FF', '#88C2D0',
            '#FF8AEF', '#FFDB5C', '#88DCBE', '#FC984D', '#99CCF9',
            '#FC9ECF', '#D0A3FF', '#ADB5FF', '#F4977F', '#FFA992',
            '#FF778', '#DA9DE9', '#FFC6C6', '#A8C272', '#A7C2FF',
            '#C5FF4E', '#F783C8', '#FFB49F', '#E5CD62', '#A3FF9E',
            '#A8C28C', '#8DD2FF', '#FFAB67', '#E7AF6D', '#6CDA7E',
            '#FFB856', '#F599B7', '#A8BCE0', '#FCB3FF'
        ];

        // Format Date/Time from Schedule Data
        let timeStr = '';
        if (data.start_date) {
            const startTime = data.start_date.split(' ').pop();
            timeStr = `${startTime}${data.end_time ? ' - ' + data.end_time : ''}`;
        }

        const speakersHtml = (data.catalyst && Array.isArray(data.catalyst))
            ? data.catalyst.map((speaker, index) => {
                const color = colors[index % colors.length];
                const imgUrl = speaker.image_url || '';

                return `
                <div class="timetable-modal__speaker">
                    <figure class="timetable-modal__speaker-img" style="border-color: ${color};">
                         <img src="${imgUrl}" alt="${speaker.name}">
                    </figure>
                    <div class="timetable-modal__speaker-info">
                        <p class="timetable-modal__speaker-name">${speaker.name || ''}</p>
                        <p class="timetable-modal__speaker-pos">${speaker.position || ''}</p>
                    </div>
                </div>
                `;
            }).join('')
            : '';

        // Conditionally render fields only if they exist
        const timeHtml = timeStr ? `<p class="timetable-modal__row modalTime">${timeStr}</p>` : '';
        const placeHtml = data.session_place ? `<p class="timetable-modal__row modalPlace">${data.session_place}</p>` : '';
        const infoHtml = data.information_text ? `<p class="timetable-modal__row modalInformationText">${data.information_text}</p>` : '';

        modalBody.innerHTML = `
            ${timeHtml}
            <!-- ${placeHtml} -->
            <h3 class="timetable-modal__title">${data.title || ''}</h3>
            ${infoHtml}
            <div class="timetable-modal__speakers">
                ${speakersHtml}
            </div>
        `;
        modal.classList.add('is-active');
        document.documentElement.classList.add('no-scroll');
        document.body.classList.add('no-scroll');
    };

    // Helper to fetch JSON from a URL
    const fetchJson = async (url) => {
        try {
            const res = await fetch(url);
            if (!res.ok) throw new Error(`Fetch failed for ${url}`);
            const data = await res.json();
            return data;
        } catch (e) {
            console.error(e);
            return null;
        }
    };

    // Helper to normalize data array
    const normalizeData = (data) => {
        return Array.isArray(data) ? data : (data?.data || []);
    };

    // Helper to normalize tags (full-width to half-width, lowercase)
    const normalizeTag = (tag) => {
        if (!tag) return '';
        return tag
            .replace(/[Ａ-Ｚａ-ｚ０-９]/g, (s) => String.fromCharCode(s.charCodeAt(0) - 0xFEE0))
            .toLowerCase();
    };

    const init = async () => {
        const btns = document.querySelectorAll('.modal-btn, .close');
        btns.forEach(btn => {
            btn.classList.add('is-loading');
            if (btn.classList.contains('child')) {
                btn.style.minHeight = '12rem';
            }
        });

        // API Endpoints
        // Schedule: grouped_articles_cmn (has time/place, uses 'free_tag')
        // Content: group_all (has title/speakers, uses 'tags')
        const SCHEDULE_27 = 'https://cmnapi.uoc.world/v1/grouped_articles_cmn?group_article_id=GRP01367';
        const CONTENT_27 = 'https://api.uoc.world/v1/group_all?ref_id=GRP01367';

        const SCHEDULE_28 = 'https://cmnapi.uoc.world/v1/grouped_articles_cmn?group_article_id=GRP01368';
        const CONTENT_28 = 'https://api.uoc.world/v1/group_all?ref_id=GRP01368';

        // 1. Fetch all data
        const [sch27Raw, con27Raw, sch28Raw, con28Raw] = await Promise.all([
            fetchJson(SCHEDULE_27),
            fetchJson(CONTENT_27),
            fetchJson(SCHEDULE_28),
            fetchJson(CONTENT_28)
        ]);

        const schedule27 = normalizeData(sch27Raw);
        const content27 = normalizeData(con27Raw);
        const schedule28 = normalizeData(sch28Raw);
        const content28 = normalizeData(con28Raw);


        // 2. Merge Logic
        const mergeData = (scheduleItems, contentItems, day) => {
            // Index content items by their tags for easy lookup
            // Assumption: Tags are unique enough to map 1-to-1 for the same session
            const contentMap = new Map();
            contentItems.forEach(item => {
                if (item.tags && Array.isArray(item.tags)) {
                    item.tags.forEach(tag => contentMap.set(normalizeTag(tag), item));
                }
            });

            // Map schedule items to merged objects
            return scheduleItems.map(sch => {
                // Find matching content
                let match = null;
                if (sch.free_tag && Array.isArray(sch.free_tag)) {
                    for (const tag of sch.free_tag) {
                        const nTag = normalizeTag(tag);
                        if (contentMap.has(nTag)) {
                            match = contentMap.get(nTag);
                            break;
                        }
                    }
                }

                // If no match found, use schedule item as base (or skip?)
                // We'll use schedule as base because it drives the grid slots
                const merged = {
                    ...sch,
                    ...(match || {}),
                    // Priority overwrites if needed, but usually:
                    // Time/Place come from sch
                    // Title/Speakers from match
                    start_date: sch.start_date,
                    end_time: sch.end_time,
                    session_place: sch.session_place,

                    // Prefer Content title/catalyst if available, otherwise fallback to schedule's
                    title: match?.title || sch.title,
                    catalyst: match?.catalyst || sch.catalyst,
                    information_text: match?.information_text || sch.information_text,

                    // Keep tags for reference
                    tags: sch.free_tag || [],
                    _day: day
                };
                return merged;
            });
        };

        const merged27 = mergeData(schedule27, content27, '27');
        const merged28 = mergeData(schedule28, content28, '28');
        const allArticles = [...merged27, ...merged28];

        // 3. Render Layout
        const filledSlots27 = [];
        const filledSlots28 = [];

        const renderArticle = (article) => {
            if (!article.tags || article.tags.length === 0) return;

            article.tags.forEach(tag => {
                const nTag = normalizeTag(tag);
                const targetEls = document.querySelectorAll(`[data-position="${nTag}"]`);

                targetEls.forEach(targetEl => {
                    // Track filled slots based on Day ID container
                    if (targetEl.closest('#date27')) {
                        filledSlots27.push(targetEl);
                    } else if (targetEl.closest('#date28')) {
                        filledSlots28.push(targetEl);
                    }

                    // Extract time
                    let time = '';
                    if (article.start_date) {
                        const startTime = article.start_date.split(' ').pop();
                        time = `${startTime}${article.end_time ? ' - ' + article.end_time : ''}`;
                    }

                    const speakerNames = (article.catalyst && Array.isArray(article.catalyst))
                        ? article.catalyst.map(sp => sp.name).filter(Boolean).join('／')
                        : '';

                    // Reset content first to remove any static placeholders
                    // We will re-apply magic container dynamically later
                    targetEl.innerHTML = `
                        <p class="time">${time}</p>
                        <p class="title">${article.title || ''}</p>
                        <p class="catalyst">${speakerNames}</p>
                    `;

                    targetEl.classList.remove('is-loading');
                    targetEl.addEventListener('click', () => {
                        openModal(article);
                    });
                });
            });
        };

        allArticles.forEach(renderArticle);

        // Magic Container Logic
        const applyMagicContainer = (day) => {
            const dayContainer = document.querySelector(`.timeTable__date${day}`);
            if (!dayContainer) return;

            // 1. Remove ANY existing magic-containers in this Day (cleanup static HTML)
            const existingMagics = dayContainer.querySelectorAll('.magic-container');
            existingMagics.forEach(el => {
                const parent = el.parentNode;
                while (el.firstChild) {
                    parent.insertBefore(el.firstChild, el);
                }
                parent.removeChild(el);
            });

            // 2. Prepare Gathering HTML based on Day & Target Slot
            let gatheringHtml = '';
            let targetId = '';

            if (day === '27') {
                targetId = '#m08';
                gatheringHtml = `
                    <div class="gathering">
                        <p class="time">20 : 00 - 21 : 00</p>
                        <p class="catalyst">Gathering / 懇親会</p>
                    </div>`;
            } else if (day === '28') {
                targetId = '#m15';
                gatheringHtml = `
                    <div class="gathering">
                        <p class="time">18 : 15 - 20 : 00</p>
                        <p class="catalyst">Gathering / 懇親会</p>
                    </div>`;
            }

            const targetSlot = dayContainer.querySelector(`[data-position="${targetId}"]`);
            if (!targetSlot) return;

            // 3. Wrap the content of the TARGET slot in magic-container with Gathering info
            const currentContent = targetSlot.innerHTML;
            targetSlot.innerHTML = `<div class="magic-container">${gatheringHtml}<div class="fit-content">${currentContent}</div></div>`;
        };

        applyMagicContainer('27');
        applyMagicContainer('28');

        // Cleanup loading states
        btns.forEach(btn => {
            btn.classList.remove('is-loading');
            if (btn.classList.contains('child')) {
                btn.style.minHeight = '';
            }
        });
    };

    init();
};
